import styled from 'styled-components';

export const SetupTitle = styled.h3`
  margin-bottom: 1rem;
  color: #4A4A4A;
`